import React from 'react';
import { Menu, Checkbox } from 'semantic-ui-react';
import { capitalize } from '../../utils/utils';

export const MenuItem = (props) => {
  const { filter, selectedFilters, changeFilter, name, title } = props;
  const isSelected =
    selectedFilters &&
    selectedFilters.values &&
    selectedFilters.values.indexOf(filter.value) !== -1;
  const label = `${capitalize(filter.value)} (${filter.count})`;

  return (
    <Menu.Item>
      <Checkbox
        label={
          label.includes('Symplexity-created')
            ? `Corsica-created ` + label.split(' ')[1]
            : label
        }
        checked={!!isSelected}
        onChange={() =>
          isSelected
            ? changeFilter({
                name,
                title,
                value: filter.value,
                selected: false
              })
            : changeFilter({ name, title, value: filter.value, selected: true })
        }
      />
    </Menu.Item>
  );
};

export default MenuItem;
